<template>
    <div>

        <rkm-row>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.circunferenciaAbdominal"
                    append="cm"
                    label="Circunferência abdominal"
                    placeholder="000"
                    v-mask="masks.circunferenciaAbdominal"
                    v-model="model.circunferenciaAbdominal"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.perimetroPanturrilha"
                    append="cm"
                    label="Perímetro da panturrilha"
                    placeholder="00"
                    v-mask="masks.perimetroPanturrilha"
                    v-model="model.perimetroPanturrilha"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.pressaoArterial"
                    label="Pressão arterial"
                    placeholder="000/000"
                    v-mask="'###/###'"
                    v-model="model.afericaoPa"
                    :disabled="isDisabledLimite() && !model.afericaoPa || isDisabledInformacoes(enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mmHg
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.frequenciaRespiratoria"
                    label="Frequência respiratória"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="model.frequenciaRespiratoria"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mpm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.frequenciaCardiaca"
                    label="Frequência cardíaca"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="model.frequenciaCardiaca"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            bpm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.temperatura"
                    label="Temperatura"
                    placeholder="00,0"
                    v-mask="'##.#'"
                    v-model="model.temperatura"
                    :disabled="isDisabledLimite() && !model.temperatura || isDisabledInformacoes(enums.procedimento.AFERICAO_DE_TEMPERATURA)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            °C
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.saturacaoO2"
                    label="Saturação de O2"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="model.saturacaoO2"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            %
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.peso"
                    append="kg"
                    label="Peso"
                    placeholder="000.00"
                    v-mask="pesoMask"
                    v-model="model.peso"
                    :disabled="isDisabledLimite() && !model.peso || isDisabledInformacoes(enums.procedimento.MEDICAO_DE_PESO)"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.altura"
                    append="cm"
                    label="Altura"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="model.altura"
                    :disabled="isDisabledLimite() && !model.altura || isDisabledInformacoes(enums.procedimento.MEDICAO_DE_ALTURA)"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.perimetroCefalico"
                    append="cm"
                    label="Perímetro cefálico"
                    placeholder="000.0"
                    v-mask="masks.perimetroCefalico"
                    v-model="model.perimetroCefalico"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.glicemia"
                    label="Glicemia capilar"
                    placeholder="000"
                    v-mask="masks.glicemia"
                    v-model="model.glicemia"
                    :disabled="isDisabledLimite() && !model.glicemia || isDisabledInformacoes(enums.procedimento.CLICEMIA_CAPILAR)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mg/dL
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col>

                <rkm-form-select
                    :options="data.form.momentosColeta"
                    :validations="validations.momentoColeta"
                    label="Momento da coleta"
                    show-default-option
                    text-field="nome"
                    v-model="model.momentoColetaId"
                    default-option-text="Selecione"
                    value-field="id"
                    class="pt-0"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>

            <rkm-col cols="6">
                <rkm-form-checkbox
                    :label="false"
                    v-model="model.exameLaboratorial"
                    class="pt-0"
                    :disabled="isDisabledLimite() && !model.exameLaboratorial || isDisabledInformacoes(enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)"
                >
                    Coleta de material para exame laboratorial
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
//Enums
import procedimento from '@/enums/sigtap/procedimento'
import limite from '@/enums/atencao-basica/procedimento/limite'

// Mixins.
import { repository, object, formats, stringCase, mask, data } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                perimetroCefalico: { min_value: 10, max_value: 200 },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                glicemia: { required: this.model.momentoColetaId ? true : false, min_value: 0, max_value: 800 },
                momentoColeta: { required: this.model.glicemia ? true : false },
                circunferenciaAbdominal: { max_value: 999 },
                perimetroPanturrilha: { min_value: 10, max_value: 99 },
                frequenciaRespiratoria: { min_value: 0, max_value: 200 },
                frequenciaCardiaca: {max_value: 999},
                temperatura: { min_value: 20, max_value: 45 },
                saturacaoO2: { min_value: 0, max_value: 100 },
            }
        },
        maskPeso() {

            const value = this.model && this.model.peso ? this.model.peso : null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 1) {
                        return '#.###';
                    } else if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '###';
        },
        maskAltura() {

            const value = this.model.altura ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '###';
        },
        maskTemperatura() {

            return '##.#';
        },
        pesoMask() {

            const length = (this.model.peso ?? '').replace('.', '').length

            if (length <= 3) {

                return '#.##'
            }
            else if (length <= 4) {

                return '##.##'
            }
            else {

                return '###.##'
            }
        },
    },
    methods: {
        isRequired() {

            return !this.model.escutaInicial
                && !this.model.peso
                && !this.model.altura
                && !this.model.afericao
                && !this.model.glicemia
                && !this.model.temperatura
                && !this.model.exameLaboratorial
                && this.model.procedimentoPequenaCirurgia.length === 0
                && this.model.testeRapido.length === 0
                && this.model.administracaoMedicamento.length === 0
                && this.model.procedimentos.length === 0
        },
        isDisabledLimite() {

            if (Object.keys(this.model).length > 0) {
                const limite = this.handleLimite()
                return limite >= this.enums.limite.QUANTIDADE ? true : false
            }

            return false
        },
        handleLimite() {

            const quantidadeEscutaInicial = this.model.escutaInicial ? 1 : 0

            const limite = quantidadeEscutaInicial
                + this.model.procedimentoPequenaCirurgia.length
                + this.model.testeRapido.length
                + this.model.administracaoMedicamento.length
                + this.model.procedimentos.length

            return limite
        },
        isDisabledInformacoes(codigo) {

        return this.data.model.procedimentoUsuario
            && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == codigo).isDisabled
        },
        addProcedimento(codigoProcedimento){

            const procedimento = this.data.form.procedimentos.find(procedimento =>
                procedimento.codigo == codigoProcedimento)
            const existe = this.model.procedimentos.find(procedimento => procedimento.codigo == codigoProcedimento)

            if (existe) {
                return false
            }

            const limite = this.handleLimite()

            if (limite >= this.enums.limite.QUANTIDADE) {
                this.showAlert('Foi atingido o limite de 20 procedimentos por ficha.', "Atenção")
                return false
            }

            if (procedimento) {

                const param = {
                    id: procedimento.id,
                    nome: procedimento.nome,
                    codigo: procedimento.codigo,
                }

                this.model.procedimentos.push(this.clone(param))
            }
        },
    },
    data: () => ({
        enums: {
            procedimento,
            limite,
        },
        masks: {
            altura: '###',
            circunferenciaAbdominal: '###',
            perimetroCefalico: '###.#',
            perimetroPanturrilha: '##',
            peso: '###.##',
            glicemia: '###',
        },
    }),
    mixins: [ repository, object, formats, stringCase, mask, data ],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.peso': function (peso) {

            if (peso) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)

                if (this.model.altura) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_PESO)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'model.altura': function (altura) {

            if (altura) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (this.model.peso) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'model.temperatura': function (febre) {

            if (febre) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AFERICAO_DE_TEMPERATURA)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
        'model.afericaoPa': function (afericao) {

            if (afericao) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
        'model.glicemia': function (glicemia) {

            if (glicemia) {
                this.addProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.GLICEMIA_CAPILAR)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
        'model.exameLaboratorial': function (exameLaboratorial) {

            if (exameLaboratorial) {
                this.addProcedimento(this.enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>